"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnvironment = void 0;
const createEnvironment = ({ requestUrl, experiments = {}, isQaMode, trackClicksAnalytics = false, useSandboxInHTMLComp = false, viewMode = 'desktop', previewMode = false, editorType = 'RESPONSIVE', editorName = 'Studio', deviceType, isWixSite = false, metaSiteId = '', mainPageId = '', userId = '', domain = '', language = 'en', languageDirection = 'ltr', }) => {
    const window = globalThis.window;
    const url = requestUrl || window?.location?.href || '';
    const urlParams = url ? new URL(url).searchParams : '';
    const shouldForce = url.toLowerCase().includes('forcereducedmotion');
    return {
        experiments,
        isExperimentOpen: (experimentName) => Boolean(experiments[experimentName]),
        reducedMotion: shouldForce || !!window?.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches,
        isQaMode: isQaMode || (urlParams ? urlParams.get('isqa') === 'true' : false),
        trackClicksAnalytics,
        useSandboxInHTMLComp,
        viewMode,
        getPreviewMode: () => previewMode,
        editorType,
        editorName,
        deviceType: deviceType || (viewMode === 'mobile' ? 'Smartphone' : 'Desktop'),
        isMobileView: viewMode === 'mobile' && editorType !== 'RESPONSIVE',
        isWixSite,
        getMetaSiteId: () => metaSiteId,
        mainPageId,
        userId,
        domain,
        language,
        getLanguageDirection: () => languageDirection,
        isSSR: () => !window,
    };
};
exports.createEnvironment = createEnvironment;
//# sourceMappingURL=environment.js.map